import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastr:ToastrService) { }

  errorMsg(msg) {
    this.toastr.error(msg);
  }
  successMsg(msg) {
    this.toastr.success(msg);
  }
}
